export class RoleModel {
  id = 1;
  name = 'User';
}
